module.exports = __webpack_public_path__ + "img/top_logo.18636de9.png";